// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import AgreeButtonController from "./agree_button_controller"
application.register("agree-button", AgreeButtonController)

import CanvasController from "./canvas_controller"
application.register("canvas", CanvasController)

import DesignSelectorController from "./design_selector_controller"
application.register("design-selector", DesignSelectorController)

import DialogueController from "./dialogue_controller"
application.register("dialogue", DialogueController)

import EstimateController from "./estimate_controller"
application.register("estimate", EstimateController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HistoryController from "./history_controller"
application.register("history", HistoryController)

import ImageModalController from "./image_modal_controller"
application.register("image-modal", ImageModalController)

import ItemVariantController from "./item_variant_controller"
application.register("item-variant", ItemVariantController)

import JpostalController from "./jpostal_controller"
application.register("jpostal", JpostalController)

import MemberPointsController from "./member_points_controller"
application.register("member-points", MemberPointsController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import PreventEnterController from "./prevent_enter_controller"
application.register("prevent-enter", PreventEnterController)

import PriceSheetController from "./price_sheet_controller"
application.register("price-sheet", PriceSheetController)

import ProductImageController from "./product_image_controller"
application.register("product-image", ProductImageController)

import SmartphoneController from "./smartphone_controller"
application.register("smartphone", SmartphoneController)

import StickyController from "./sticky_controller"
application.register("sticky", StickyController)

import SwiperController from "./swiper_controller"
application.register("swiper", SwiperController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import UploadsController from "./uploads_controller"
application.register("uploads", UploadsController)

import UtilityController from "./utility_controller"
application.register("utility", UtilityController)
